/**
 * Created by Administrador on 10/17/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig)

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('branchOffices', {
                parent: 'app',
                url: '/branchOffices?page&size',
                params: {
                    page: "0",
                    size: "10"
                },
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/branchOffice/branchOffices.html',
                        controller: 'branchOfficesController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['translationHandler', function (translationHandler) {
                        return translationHandler.translateRefresh(['branchOffice']);
                    }],
                    branchOffices: ['branchOfficeService','$stateParams', function(branchOfficeService,$stateParams){
                        return branchOfficeService.getBranchOffices($stateParams.page, $stateParams.size,true)
                    }]
                }
            })
            .state('branchOfficeNew', {
                parent: 'app',
                url: '/branchOffice/new',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/branchOffice/newBranchOffice.html',
                        controller: 'newBranchOfficeController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['translationHandler', function (translationHandler) {
                        return translationHandler.translateRefresh(['branchOffice']);
                    }],
                    countries: ['countryService', function(countryService){
                        return countryService.getActiveCountries(true, false)
                    }]
                }
            })
            .state('branchOfficeEdit', {
                parent: 'app',
                url: '/branchOffice/:id/edit',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/branchOffice/editBranchOffice.html',
                        controller: 'editBranchOfficeController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['translationHandler', function (translationHandler) {
                        return translationHandler.translateRefresh(['branchOffice']);
                    }],
                    branchOfficeId: ['$stateParams', function($stateParams){
                        return $stateParams.id;
                    }],
                    branchOffice: ['branchOfficeService', '$stateParams', function(branchOfficeService, $stateParams){
                        return branchOfficeService.getBranchOffice($stateParams.id)
                    }],
                    countries: ['countryService', function(countryService){
                        return countryService.getActiveCountries(true, false)
                    }]
                }
            })
            .state('branchOfficeDelete', {
                parent: 'branchOffices',
                url: '/branchOffice/:id/delete',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/configGeneral/branchOffice/deleteBranchOffice.html',
                        controller: 'deleteBranchOfficeController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            'branchOfficeId': [function() {
                                return $stateParams.id
                            }],
                            'branchOffice': ['branchOfficeService', function(branchOfficeService) {
                                return branchOfficeService.getBranchOffice($stateParams.id)
                            }]
                        }
                    }).result.then(function() {
                        $state.go('branchOffices', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            });
    }
})();
